export default {
    subStr(str, n) {
        return str.substr(0, n);
    }
}


// WEBPACK FOOTER //
// ./app/assets/js/filter.js